var map = {
	"./Atal_1.png": 677,
	"./Atul_4.png": 276,
	"./Banti-Babu_3.png": 344,
	"./Maninsh-Karn_8.png": 797,
	"./Prashant_9.png": 124,
	"./Prince_2.png": 225,
	"./Raunak_7.png": 877,
	"./Srijan_5.png": 906,
	"./Vaibhaw-Karn_10.jpg": 876,
	"./Vaibhaw_6.png": 988
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 455;